<template>
  <span class="mit-key-spaces">
      <span v-for="(space, i) in spaces" :key="i">
      <v-tooltip top max-width="400" color="#333" offset-overflow style="opacity: 1!important;" >
        <template v-slot:activator="{ on }">
            <!-- The vbind attr and vbind on is needed to pass the tooltip events to the v-chip. -->
            <v-chip :color="spacesDetails[i] && spacesDetails[i].spaceExists ? '': 'red'" :small="size === 'small'" :class="(search.text.length > 0 && space.indexOf(search.text.toUpperCase()) > -1 )?'primary':''" label :dark="dark" class="ma-1" v-bind="attrs" v-on="on">
              {{ space }}
            </v-chip>
        </template>
        <!-- <h3>DETAILS:</h3> -->
        <h3>{{space}}</h3>
        <v-divider color="white"></v-divider>
        <div v-if="spacesDetails[i] && spacesDetails[i].spaceExists">
            <!-- <span><b>Id</b>: {{spacesDetails[i].mitId + ' ' + spacesDetails[i].name }}</span><br> -->
            <span><b>Building</b>: {{spacesDetails[i].building }}</span><br>
            <span><b>Floor</b>: {{spacesDetails[i].level}}</span><br>
            <span><b>Org</b>: {{spacesDetails[i].org}}</span>
        </div>
        <div v-else>
            <!-- <span><b>Id</b>: {{space}}</span><br> -->
            <span>This space could not be located in the spaces application! Please make sure this space exists.</span>
        </div>
      </v-tooltip>
    </span>
  </span>
</template>

<script>

export default {
  name: 'MitKeySpaces',
  props: {
    size:{
      default: 'normal',
      type: String
    },
    dark:{
      default: true,
      type: Boolean
    },
    search:{
      default: {
        text:''
      },
      type: Object
    },
    spaces:{
      default: [],
      type: Array
    },
    spacesDetails:{
        default: [],
        type: Array
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
